import { Navigate, Outlet } from "react-router";
import { useAuthContext } from "contexts";

const VerifyRoutes = () => {
  const { userSession } = useAuthContext();

  if (!userSession) {
    return <Navigate to="../" replace />;
  }

  return <Outlet />;
};

export default VerifyRoutes;
